import * as React from "react";
const FilterHeader = (props) => {
  return /* @__PURE__ */ React.createElement("div", { className: "filter__section filter__section--header" }, /* @__PURE__ */ React.createElement("div", { className: "filter__content" }, props.children));
};
export {
  FilterHeader
};
